import { useQuery } from '@tanstack/react-query';

import AudiencesService from '@/services/AudiencesService';

export const GET_AUDIENCES_DEFAULT_QUERY_KEY = ['audiences-default'];

export default function useGetAudiencesDefault() {
  const { data, isFetching } = useQuery({
    queryKey: GET_AUDIENCES_DEFAULT_QUERY_KEY,
    queryFn: () => AudiencesService.getAudiencesDefault(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  return {
    audiencesDefault: data ?? [],
    isLoading: isFetching,
  };
}
